<template>
  <div
    v-if="localValue.type === 'accept'"
    :id="'localValue' + index"
  >
    <div
      class="flex"
      :style="
        'padding: ' + styles.padding.join('px ') + 'px;' + 
        'margin: ' + styles.margin.join('px ') + 'px;' + 
        'justify-content: ' + styles.text.textAlign + ';' +

        'font-family:' + (styles.text.fontFamily || '') + ';' + 
        'text-shadow:' + (styles.text.textShadow || '') + ';' + 
        'font-size:' + styles.text.fontSize + 'px;' + 
        'text-align:' + styles.text.textAlign + ';' + 
        'font-style:' + (styles.text.fontStyle || '') + ';' +
        'font-weight:' + (styles.text.fontWeight || '') + ';' +
        'letter-spacing:' + (styles.text.letterSpacing || '') + ';' +
        'line-height:' + (styles.text.lineHeight || '') + ';' +
        '-webkit-text-stroke-width:' + (styles.text.textStrokeWidth || '') + ';' +
        '-webkit-text-stroke-color:' + (styles.text.textStrokeColor || '') + ';' +
        'text-decoration-line:' + (styles.text.textDecorationLine || '') + ';' +
        'color:' + styles.text.color + ';' +
        styles.customStyles ?? ''
      "
    >
      <label class="container text-sm" style="display: inline-block; width: auto;">
        {{ localValue.placeholder }}
        <input type="checkbox"/>
        <span 
          class="checkmark" 
          :style="
          '--form-style-color:' + styles.iconColor + ';' +
          '--form-style-background:' + styles.backgroundColor"
        ></span>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FormCheckbox',
  props: {
    value: {
      required: true,
    },
    index: {
      required: true,
    },
    styles: {
      required: true,
    },
  },
  computed: {
    localValue: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    hide() {
      this.localValue = '';
      this.localShown = false;
    },
    onTextChange(e) {
      console.log(e.target.innerText);
      this.localValue = e.target.innerText;
    },
  }
}
</script>
